export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  summary: string;
  content: string;
  coverImage: string;
  author: string;
  publishDate: string;
  tags: string[];
  viewCount: number;
  commentCount: number;
  isHot: boolean;
  isNew: boolean;
  featuredOrder?: number;
}

export const categories: { name: string; slug: string; icon: string; description: string }[] = [
  { name: '网红塌房', slug: 'wanghong-tafang', icon: 'ri-alert-fill', description: '网红翻车现场全记录，明星博主塌房第一手消息' },
  { name: '博主反差', slug: 'bozhu-fancha', icon: 'ri-contrast-2-fill', description: '揭秘博主镜头前后的巨大反差，人设崩塌实录' },
  { name: '每日大赛', slug: 'meiri-dasai', icon: 'ri-fire-fill', description: '每日最新网络热点事件，吃瓜群众不容错过' },
  { name: '热门爆料', slug: 'remen-baoliao', icon: 'ri-flashlight-fill', description: '匿名爆料专区，汇集全网最新内幕消息' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '千万粉丝美妆博主"甜心酱"直播翻车，素颜状态引发全网热议',
    slug: 'qianwan-fensi-meizhuang-bozhu-zhibo-fanche',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '坐拥1200万粉丝的美妆博主甜心酱在一次直播中因设备故障意外展示素颜，与平日精修照片反差巨大，引发粉丝激烈讨论，话题一度冲上热搜榜首。',
    content: `<p>近日，拥有超过1200万粉丝的美妆博主"甜心酱"在一次日常直播中，因美颜软件突然崩溃，意外展示了未经任何滤镜和美颜处理的真实面容，与平日发布的精修照片形成了鲜明对比。</p><p>据直播间观众描述，当时甜心酱正在试涂一款新口红，突然画面卡顿了一下，随后美颜效果全部失效。弹幕瞬间炸开了锅，不少粉丝表示"完全认不出来了"。</p><p>事件发生后，#甜心酱翻车# 话题迅速登上微博热搜，阅读量在短短两小时内突破3亿。有网友翻出甜心酱此前发布的精修自拍与直播截图进行对比，差距确实相当明显。</p><p>面对舆论风波，甜心酱随后发布了一条道歉视频，表示"每个人都有不完美的一面，感谢愿意接受真实的我的人"。该视频发布后，其粉丝数量反而增长了约50万，不少网友表示"真实的你更可爱"。</p><p>业内人士分析认为，这次"翻车"事件虽然短期内引发了争议，但甜心酱诚恳的应对方式反而赢得了更多路人的好感，可以说是一次"反向涨粉"的经典案例。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20beauty%20blogger%20live%20streaming%20studio%20setup%20with%20ring%20light%2C%20makeup%20products%20on%20desk%2C%20dramatic%20lighting%20contrast%2C%20editorial%20photography%20style%2C%20warm%20and%20cool%20tones%2C%20professional%20studio%20atmosphere%2C%20subtle%20drama%20mood%2C%20clean%20background%20with%20soft%20bokeh&width=800&height=500&seq=article-cover-01&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-06',
    tags: ['美妆博主', '直播翻车', '甜心酱', '素颜', '滤镜'],
    viewCount: 128600,
    commentCount: 3542,
    isHot: true,
    isNew: false,
    featuredOrder: 1,
  },
  {
    id: '2',
    title: '知名吃播博主"大胃王阿强"被曝假吃剪辑，幕后团队遭前员工实名举报',
    slug: 'zhibo-bozhu-aqiang-beibao-jiachi-jianji',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    summary: '拥有800万粉丝的吃播博主大胃王阿强被前团队成员爆料，其视频存在大量剪辑拼接和假吃行为，所谓"一餐吃十斤"完全是视觉欺骗。',
    content: `<p>吃播圈再起波澜！近日，一位自称是知名吃播博主"大胃王阿强"前团队成员的用户在社交平台发布长文，详细揭露了阿强视频背后的"造假产业链"。</p><p>据爆料者称，阿强所谓的"一餐吃十斤"其实是通过精细的视频剪辑技术完成的。拍摄时阿强只需要吃少量食物并做出夸张表情，后期团队会通过画面拼接、加速播放等手法营造出"大胃王"的假象。剩余的食材则被直接丢弃，造成了严重的食物浪费。</p><p>该爆料帖配有多张后台工作照和视频制作流程图，证据相当详实。帖子发布后，迅速在各平台发酵，话题#大胃王阿强假吃#阅读量突破5亿。</p><p>面对汹涌的舆论，阿强方面至今未做出正式回应，但其账号最近三天已停止更新，评论区也已关闭。多个品牌方已紧急下架了与阿强的合作广告。</p><p>网络视听协会相关人士表示，虚构大胃王人设并大量浪费食物，不仅涉嫌欺骗消费者，也违背了社会公序良俗，相关部门或将介入调查。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20mukbang%20food%20eating%20show%20set%20with%20large%20table%20filled%20with%20various%20dishes%2C%20dramatic%20studio%20lighting%2C%20professional%20video%20equipment%20visible%2C%20warm%20food%20tones%2C%20dark%20moody%20background%2C%20editorial%20style%2C%20high%20contrast%20photography%2C%20cinematic%20atmosphere&width=800&height=500&seq=article-cover-02&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-06',
    tags: ['吃播', '造假', '大胃王', '剪辑', '实名举报'],
    viewCount: 256300,
    commentCount: 8721,
    isHot: true,
    isNew: true,
    featuredOrder: 2,
  },
  {
    id: '3',
    title: '网红情侣"奶茶夫妇"官宣分手，互撕聊天记录曝光震惊全网',
    slug: 'wanghong-qinglv-naicha-fufu-fenshou',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    summary: '曾被誉为"最甜情侣博主"的奶茶夫妇突然宣布分手，双方随即在社交平台互相曝光私密聊天记录，内容劲爆程度让吃瓜群众直呼过瘾。',
    content: `<p>7月5日晚间，拥有1500万粉丝的情侣博主组合"奶茶夫妇"（@奶茶先生 & @奶茶小姐）同时发布分手声明，宣布结束三年的情侣关系。</p><p>然而分手声明仅仅是个开始。在随后不到一小时的时间里，双方开始在各自的社交账号上互相曝光对方的私密聊天记录截图，内容涉及出轨、经济纠纷以及私下对粉丝的负面评价等，信息量巨大。</p><p>奶茶先生首先发难，晒出多张截图声称女方在恋爱期间与多名男主播保持暧昧关系。奶茶小姐则迅速反击，曝光了男方"利用情侣人设骗取粉丝打赏"的聊天记录，并指责对方存在家暴倾向。</p><p>这场"互撕大战"持续了整整一夜，双方的聊天记录被吃瓜网友逐帧分析，各种"锤"和"反锤"让人目不暇接。#奶茶夫妇互撕# 话题持续占据热搜第一超过12小时。</p><p>截止发稿时，双方已删除相关微博，但截图已在全网广泛传播。多位圈内人士对此表示"这对是人设崩塌最快的情侣博主，没有之一"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Couple%20arguing%20dramatically%20with%20smartphones%20in%20hand%2C%20split%20composition%20showing%20two%20people%20back%20to%20back%2C%20warm%20and%20cold%20lighting%20contrast%2C%20modern%20apartment%20setting%2C%20emotional%20tension%2C%20editorial%20photography%2C%20cinematic%20mood%2C%20clean%20minimal%20background&width=800&height=500&seq=article-cover-03&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-05',
    tags: ['情侣博主', '分手', '聊天记录', '互撕', '奶茶夫妇'],
    viewCount: 489200,
    commentCount: 15230,
    isHot: true,
    isNew: false,
    featuredOrder: 3,
  },
  {
    id: '4',
    title: '某知名游戏主播直播间骂人录音外泄，平台连夜封禁账号',
    slug: 'zhiming-youxi-zhubo-maren-luyin',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '一位拥有300万粉丝的游戏主播私下辱骂粉丝的录音被曝光，语言极其恶劣，引发众怒。直播平台已对其账号进行了永久封禁处理。',
    content: `<p>7月4日深夜，一段长达8分钟的录音在各大社交平台疯传。录音中，一位拥有300万粉丝的游戏主播用极其粗暴的语言辱骂自己的粉丝群体，甚至涉及地域歧视和人身攻击。</p><p>据知情人士透露，该录音是该主播在一次线下聚会上所说的话，被当时在场的某位粉丝偷偷录制。录音中的主播仿佛换了一个人，与直播间里那个"亲民、幽默"的形象判若两人。</p><p>"我直播间那些人就是韭菜，你不割自然有人割"、"那群人傻钱多的就配被当猴耍"——录音中这样的言论比比皆是，令人不寒而栗。</p><p>录音曝光后，舆论瞬间引爆。大量粉丝表示"心寒"，纷纷在评论区要求道歉。该主播所在的直播平台反应迅速，于7月5日凌晨发布公告，宣布对其账号进行永久封禁，并表示将配合相关部门进一步调查是否存在诱导消费等违规行为。</p><p>此次事件再次引发了公众对于主播行业生态的讨论。有媒体评论指出，主播行业的准入门槛和职业规范亟待完善，不能让"割韭菜"成为行业潜规则。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20studio%20with%20multiple%20monitors%20and%20RGB%20lighting%2C%20gaming%20chair%2C%20dark%20dramatic%20atmosphere%2C%20professional%20streaming%20setup%2C%20moody%20lighting%20with%20red%20accents%2C%20editorial%20photography%20style%2C%20tense%20mood%2C%20high%20contrast&width=800&height=500&seq=article-cover-04&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-05',
    tags: ['游戏主播', '辱骂粉丝', '封号', '录音外泄', '平台处罚'],
    viewCount: 345100,
    commentCount: 9876,
    isHot: true,
    isNew: false,
    featuredOrder: 4,
  },
  {
    id: '5',
    title: '健身博主"铁血教练"被扒学历造假，北体大毕业证书竟系PS伪造',
    slug: 'jianshen-bozhu-xueli-zaojia',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    summary: '号称"北体大运动科学硕士"的健身博主铁血教练，被网友扒出其学历证书实为Photoshop伪造，其真实学历仅为高中肄业。',
    content: `<p>以"北体大运动科学硕士"头衔打造专业人设的健身博主"铁血教练"（真名：张某某），近日被网友扒出惊天秘密——他的学历证书竟然是PS的。</p><p>事情的起因是一位细心的粉丝发现铁血教练晒出的毕业证书照片中，校徽的位置与北京体育大学官方版本存在明显偏差。随后网友们展开了"考古式调查"，在学信网和学校档案馆均未查到他的学籍信息。</p><p>更令人震惊的是，有自称是其高中同学的人爆料，铁血教练高中都没读完就辍学了，后来去健身房当销售，因为"能说会道"慢慢做起了自媒体。</p><p>"他讲的那些运动科学知识，很多都是百度百科复制粘贴的，稍微专业一点的人一听就知道有问题。"一位体育院校的毕业生在评论区写道。</p><p>面对铁证如山的质疑，铁血教练于7月5日发布道歉视频，承认学历造假并宣布"无限期退网"。其账号目前已清空所有内容，多个已售出的线上健身课程面临退款危机。据估算，其课程销售额累计超过2000万元。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Fitness%20gym%20interior%20with%20weights%20and%20equipment%2C%20dramatic%20lighting%2C%20mirror%20reflection%2C%20professional%20bodybuilder%20silhouette%2C%20moody%20dark%20atmosphere%2C%20editorial%20style%2C%20high%20contrast%2C%20clean%20modern%20gym%20setting&width=800&height=500&seq=article-cover-05&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-04',
    tags: ['健身博主', '学历造假', 'PS', '退网', '退款'],
    viewCount: 189400,
    commentCount: 5621,
    isHot: false,
    isNew: false,
    featuredOrder: 5,
  },
  {
    id: '6',
    title: '短视频平台顶流"搞笑达人老王"被曝脚本团队代写，真实人设彻底崩塌',
    slug: 'gaoxiao-daren-laowang-jiaoben-daixie',
    category: '博主反差',
    categorySlug: 'bozhu-fancha',
    summary: '以"即兴搞笑"闻名的短视频博主老王，被前编剧团队成员曝光其所有视频均为精心编写的剧本，所谓"路人偶遇"全是请来的演员。',
    content: `<p>在短视频平台上拥有超过2000万粉丝的搞笑博主"老王说事"，一直以"街头即兴搞笑"、"真实路人反应"为卖点，每条视频都能获得数百万的播放量。</p><p>然而，一位自称是老王团队前编剧的用户在7月3日发布长文，揭开了"真实搞笑"背后的工业化生产流程。据其透露，老王的每一期视频都经过了至少三轮剧本打磨——从选题策划、台词设计到"路人"演员的选角，全是精心安排的结果。</p><p>"那些'偶遇'的路人其实都是横店找来的群演，日薪300元。视频里那些'自然'的反应，都是排练了好几遍的效果。"爆料人在文中写道。</p><p>该爆料人还贴出了多份剧本初稿和群演费用清单，其中一份付款记录显示，单期视频的演员费用就超过2万元。</p><p>事件发酵后，老王在直播中回应称："短视频本来就是一种表演艺术，剧本化是行业惯例。"这一回应非但没有平息争议，反而进一步激怒了粉丝。"你卖的就是'真实'人设，现在又说这是表演？"一位粉丝的评论获得了超过50万点赞。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Street%20comedy%20performance%20scene%20in%20urban%20Chinese%20city%2C%20crowd%20gathered%20watching%2C%20smartphone%20filming%2C%20dramatic%20street%20lighting%2C%20candid%20style%20photography%2C%20warm%20evening%20tones%2C%20energetic%20atmosphere%2C%20editorial%20mood&width=800&height=500&seq=article-cover-06&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-04',
    tags: ['短视频', '脚本', '演员', '造假', '老王', '人设崩塌'],
    viewCount: 312700,
    commentCount: 9432,
    isHot: true,
    isNew: false,
    featuredOrder: 6,
  },
  {
    id: '7',
    title: '网红餐厅"深夜食堂"后厨卫生触目惊心，市场监管局突击检查停业整顿',
    slug: 'wanghong-canting-houchuweisheng',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    summary: '被多位美食博主推荐的网红深夜食堂，被顾客拍到后厨老鼠乱窜的画面。市场监管部门连夜突击检查，发现多项严重卫生问题。',
    content: `<p>位于某一线城市核心商圈的网红餐厅"深夜食堂"，以"日式深夜食堂"的氛围和菜品吸引了大量食客，日均排队时间超过两小时。多位知名美食博主曾为其站台推荐，被誉为"必打卡的深夜美食"。</p><p>然而7月3日晚，一位顾客在上厕所时误入后厨区域，用手机拍下了触目惊心的画面：地上污水横流，食材直接堆放在地面，老鼠在后厨自由穿行。该顾客随即将视频上传至社交平台，迅速引发热议。</p><p>视频发布后仅两小时，当地市场监管局连夜组织执法人员对"深夜食堂"进行突击检查。检查结果显示，该餐厅存在无证从业人员、食品原料来源不明、三防设施缺失等7项严重违规问题。</p><p>目前，"深夜食堂"已被责令停业整顿，并面临最高50万元的罚款。那些曾为这家餐厅站台推荐的美食博主们，也在第一时间删除了相关推广内容，但网友的截图已经传遍全网。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20restaurant%20kitchen%20interior%20with%20dramatic%20lighting%2C%20stainless%20steel%20surfaces%2C%20food%20preparation%20area%2C%20slightly%20messy%20atmosphere%2C%20nighttime%20setting%2C%20cinematic%20photography%2C%20high%20contrast%2C%20warm%20and%20shadowy%20tones&width=800&height=500&seq=article-cover-07&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-04',
    tags: ['网红餐厅', '卫生问题', '后厨', '停业整顿', '食品安全'],
    viewCount: 198500,
    commentCount: 6543,
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    title: '知名情感博主"知心姐姐"被扒知三当三，私生活混乱人设彻底崩塌',
    slug: 'qinggan-bozhu-zhixinjiejie-chagua',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '以"情感导师"身份走红的知心姐姐，被前闺蜜爆料其长期插足他人婚姻，与其公开塑造的"独立女性"形象完全背道而驰。',
    content: `<p>在短视频平台拥有600万粉丝的情感博主"知心姐姐"，一直以"独立女性"、"情感导师"的身份为粉丝提供情感建议，操着知性优雅的人设。然而，随着其前闺蜜的一篇万字长文的发布，这一切都被彻底颠覆。</p><p>据前闺蜜爆料，知心姐姐（真名：李某）在过去三年里，与多位已婚男性保持不正当关系，其中包括她自己的粉丝和客户的丈夫。"她在视频里教别人如何经营婚姻、如何自尊自爱，私下却在破坏别人的家庭。"</p><p>爆料文中还附有多张微信聊天截图和转账记录，显示知心姐姐多次主动与已婚男性调情，并使用"特殊手段"获取对方信息。其中一位受害者的妻子也在评论区证实了这些说法。</p><p>事件曝光后，知心姐姐的账号一天之内掉粉约80万。多个品牌合作商紧急宣布解约。其工作室发布声明称"相关内容均为恶意造谣，已委托律师处理"，但并未提供任何证据来反驳前闺蜜的指控。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20modern%20studio%20setting%20with%20soft%20lighting%2C%20podcast%20microphone%20visible%2C%20warm%20neutral%20tones%2C%20professional%20atmosphere%2C%20editorial%20portrait%20style%2C%20minimal%20and%20clean%20background%2C%20subtle%20drama%20mood&width=800&height=500&seq=article-cover-08&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-03',
    tags: ['情感博主', '知三当三', '人设崩塌', '闺蜜爆料', '知心姐姐'],
    viewCount: 421800,
    commentCount: 13567,
    isHot: true,
    isNew: true,
    featuredOrder: 7,
  },
  {
    id: '9',
    title: '电商带货一哥"老罗严选"翻车，宣称"纯棉"被褥检测含化纤达80%',
    slug: 'dianshang-daihuo-laoluo-fanche',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    summary: '拥有3000万粉丝的带货主播老罗，其直播间热销的"100%纯棉四季被"被消费者送检后发现化纤含量高达80%，与其宣传严重不符。',
    content: `<p>7月2日，一位购买了"老罗严选"直播间"100%纯棉四季被"的消费者，因使用后感觉面料异常光滑而心生疑虑，遂将产品送至第三方检测机构进行检测。检测结果令人震惊：该被子中聚酯纤维（化纤）含量高达80.3%，棉含量仅为19.7%，与其宣称的"100%纯棉"相去甚远。</p><p>该消费者在社交平台晒出检测报告后，迅速引发了大量购买了同款产品的消费者的共鸣。不少人纷纷表示"难怪用起来不像纯棉"，并自发组织送检。截止目前，已有超过15份检测报告显示该产品存在严重的成分虚标问题。</p><p>"老罗严选"团队起初回应称"可能是供应商批次不同导致的个例"，但面对越来越多的检测报告，其态度明显软化。7月4日晚，老罗本人在直播中含泪鞠躬道歉，承诺"假一赔三"并启动全面退款。</p><p>然而这次翻车给"老罗严选"带来的信任危机恐怕不是简单退款能够弥补的。据第三方数据监测，其直播间7月5日的销售额较平日暴跌了约70%。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Livestream%20ecommerce%20studio%20with%20bright%20studio%20lights%2C%20product%20display%20table%20with%20bedding%20items%2C%20professional%20streaming%20setup%20with%20cameras%2C%20dramatic%20contrast%20lighting%2C%20editorial%20style%2C%20warm%20atoned%20commercial%20photography&width=800&height=500&seq=article-cover-09&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-03',
    tags: ['直播带货', '翻车', '成分虚标', '老罗', '检测报告'],
    viewCount: 398600,
    commentCount: 12098,
    isHot: true,
    isNew: false,
    featuredOrder: 8,
  },
  {
    id: '10',
    title: '00后网红"小野马"被拍深夜出入富商豪宅，清纯人设遭质疑',
    slug: 'linglinghou-wanghong-xiaoyema-fushang',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '以"清纯校花"人设走红的00后网红小野马，被狗仔拍到深夜独自出入某知名富商的私人豪宅，引发广泛猜测和讨论。',
    content: `<p>7月1日晚，知名娱乐狗仔"星探阿伟"在社交媒体发布了一组跟拍照片。照片显示，以"清纯校花"形象走红的00后网红"小野马"（本名：赵某某），于当晚11点左右独自进入某知名房地产富商位于市中心的一处私人豪宅，直至次日凌晨4点才离开。</p><p>照片一经发布，立刻在网络上引发轩然大波。小野马此前一直以"单纯学生妹"、"不染尘埃"的形象示人，社交媒体内容多为校园生活和清新自拍，被粉丝亲切地称为"全网最干净的网红"。</p><p>面对铺天盖地的质疑，小野马工作室在7月2日下午发布声明称，小野马当天是"陪同家人前往参加商务宴请"，强调"不存在任何不正当关系"。但网友很快扒出，该富商与小野马的"家人"之间并没有任何公开的商业合作记录。</p><p>"这个声明还不如不发，"一位网友的评论尖锐地指出，"凌晨四点才离开，什么宴请能吃到凌晨四点？"该评论迅速获得了超过30万点赞。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20mansion%20night%20scene%20with%20dramatic%20lighting%2C%20paparazzi%20style%20photography%2C%20silhouette%20of%20person%20entering%20grand%20entrance%2C%20warm%20golden%20interior%20light%20spilling%20out%2C%20mysterious%20atmosphere%2C%20cinematic%20mood%2C%20high%20contrast%20night%20photography&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-02',
    tags: ['00后', '网红', '清纯人设', '富商', '狗仔'],
    viewCount: 356200,
    commentCount: 11034,
    isHot: false,
    isNew: false,
  },
  {
    id: '11',
    title: '知名母婴博主推荐奶粉被曝含违禁成分，数百名宝妈联名维权',
    slug: 'muying-bozhu-naifen-weijin-chengfen',
    category: '每日大赛',
    categorySlug: 'meiri-dasai',
    summary: '多位母婴博主联合推荐的一款进口奶粉被检测出含有违禁添加剂，导致多名婴儿出现不良反应。数百名宝妈已联名向监管部门投诉。',
    content: `<p>一场涉及数百个家庭的奶粉安全风波正在持续发酵。7月1日，某地市场监管局接到多位宝妈投诉，称其购买的某款进口奶粉导致婴儿出现呕吐、腹泻等症状。经送检，该奶粉中被检出含有我国明令禁止添加的某合成成分。</p><p>令人心痛的是，这些宝妈无一例外都是通过母婴博主的推荐了解到该产品的。在过去半年里，至少有6位粉丝量超过百万的母婴博主为这款奶粉做过推广，使用了"我家宝宝也在喝"、"最放心的进口奶粉"等话术。</p><p>检测报告公布后，相关推广视频被迅速删除，6位博主的账号评论区被愤怒的宝妈们攻陷。"你的良心不会痛吗？"、"为了钱害了多少孩子！"类似的留言铺天盖地。</p><p>截至目前，已有超过300名宝妈加入了联名维权群，要求涉事博主和品牌方承担医疗费用并公开道歉。当地市场监管部门已对涉事奶粉启动全面召回程序，并表示将依法从严处理。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Baby%20milk%20powder%20cans%20on%20modern%20kitchen%20counter%2C%20soft%20natural%20lighting%2C%20clean%20minimal%20setting%2C%20slightly%20dramatic%20mood%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20professional%20composition&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-07-02',
    tags: ['母婴博主', '奶粉', '违禁成分', '联名维权', '食品安全'],
    viewCount: 276800,
    commentCount: 8976,
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '旅游博主"背包小王子"被曝偷窃酒店物品，监控视频完整记录全过程',
    slug: 'lvyou-bozhu-touqie-jiudian',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '以"精致旅行生活"为主题的旅游博主背包小王子，被某五星级酒店曝光偷窃客房内高价物品，监控视频画面清晰，网友直呼"丢人丢到国外"。',
    content: `<p>旅游博主"背包小王子"最近摊上大事了。7月1日，泰国曼谷某五星级酒店在社交媒体上发布了一段监控视频，视频中清晰显示一位住客将房间内的Bose蓝牙音箱、浴袍和多个品牌洗护用品塞入行李箱。</p><p>虽然视频对住客面部进行了马赛克处理，但眼尖的网友通过其独特的行李箱贴纸、衣着配饰以及入住时间线，迅速锁定了"背包小王子"（真名：陈某）。更打脸的是，就在事发当天，陈某还在社交平台发布了住在这家酒店的照片，配文"享受每一次精致旅行"。</p><p>面对铁证，背包小王子起初否认，称"拿走的都是酒店赠送的洗护用品"。酒店方面随即回应，浴袍和Bose音箱均不属于可带走物品范围，其行为已构成盗窃，酒店保留追究法律责任的权利。</p><p>"出国旅游偷酒店东西，太丢中国人的脸了！"评论区一片骂声。目前背包小王子已关闭评论区，但相关话题仍在持续发酵中，多个品牌已宣布终止与其合作。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20interior%20with%20modern%20design%2C%20suitcase%20open%20on%20bed%2C%20warm%20ambient%20lighting%2C%20high-end%20decor%2C%20travel%20atmosphere%2C%20editorial%20photography%20style%2C%20clean%20and%20elegant%2C%20subtle%20dramatic%20mood&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-07-01',
    tags: ['旅游博主', '偷窃', '酒店', '监控', '丢人'],
    viewCount: 287400,
    commentCount: 9201,
    isHot: false,
    isNew: false,
  },
  {
    id: '13',
    title: '匿名爆料：某顶流美食博主的"家传秘方"其实是网上买的现成调料包',
    slug: 'meishi-bozhu-jiachuanmifang',
    category: '热门爆料',
    categorySlug: 'remen-baoliao',
    summary: '一位自称业内人士的匿名用户爆料，某位以"家传秘方"为卖点的千万级美食博主，其所有菜品使用的都是某电商平台的现成复合调味料包。',
    content: `<p>近日，一位匿名用户在知名爆料平台发布了一则重磅消息：某位以"奶奶留下的家传秘方"打动无数观众、拥有超过1000万粉丝的美食博主，其视频中所有让人垂涎欲滴的菜品，实际上都是用某电商平台上售价不到20元的现成复合调味料包制作的。</p><p>爆料人附上了该博主厨房角落里多个该品牌调料包的截图，以及博主的购物记录截图。虽然博主的脸部被处理，但从厨房的装修风格和手的特征来看，与该博主的视频内容高度吻合。</p><p>"视频里说的那些秘制步骤、独家配方全是在演戏，实际就是把调料包倒进去炒一炒。"爆料人写道，"最讽刺的是，这个调料包品牌还是他的赞助商之一。"</p><p>该爆料帖发布后，#美食博主调料包# 迅速登上热搜。网友们开始对各类"家传秘方"美食博主进行地毯式"审查"，已经有多位博主的视频被扒出疑似使用同一品牌的调料包。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20kitchen%20cooking%20scene%20with%20various%20seasoning%20packets%20on%20counter%2C%20professional%20food%20photography%20setup%2C%20warm%20lighting%2C%20editorial%20style%2C%20ingredients%20scattered%2C%20subtle%20drama%20mood%2C%20clean%20composition&width=800&height=500&seq=article-cover-13&orientation=landscape',
    author: '匿名爆料者',
    publishDate: '2026-07-01',
    tags: ['美食博主', '调料包', '家传秘方', '造假', '匿名爆料'],
    viewCount: 234600,
    commentCount: 7654,
    isHot: false,
    isNew: false,
  },
  {
    id: '14',
    title: '选秀出身偶像歌手"星辰"被曝私联粉丝索要礼物，金额高达数十万',
    slug: 'xiuxiu-ousiang-xingchen-silian-fensi',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    summary: '从选秀节目出道的偶像歌手星辰，被多位粉丝联合曝光私联行为，以各种理由索要贵重礼物和红包，累计金额超过20万元。',
    content: `<p>又一位偶像翻车了。近日，多位粉丝联合在社交媒体上曝光了选秀节目出道的偶像歌手"星辰"（本名：林某某）的私联行为。所谓私联，是指艺人私下联系粉丝并索要礼物、红包等利益的行为，在饭圈属于严重违规。</p><p>据多位粉丝提供的聊天截图显示，星辰通过私人微信与粉丝建立了密切联系，以"哥哥最近手头紧"、"想换个新手机"等理由，向粉丝索要红包和礼物。其中最夸张的一次，他向一位粉丝开口要求购买价值3.8万元的名牌手表。</p><p>经粉丝统计，仅曝光的聊天记录中涉及的红包和礼物金额就已超过20万元人民币。而这些粉丝中，有不少人还是在校学生，为了"支持哥哥"不惜省吃俭用甚至借贷。</p><p>事件曝光后，星辰所在的经纪公司发布声明，承认艺人存在"不恰当的个人行为"，宣布暂停其一切演艺活动并启动内部调查。但愤怒的粉丝们并不买账，要求星辰公开道歉并退还所有违法所得。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Stage%20performance%20with%20spotlight%20on%20singer%2C%20concert%20atmosphere%2C%20dramatic%20lighting%2C%20music%20performance%20scene%2C%20large%20audience%20silhouettes%2C%20editorial%20photography%2C%20warm%20stage%20lights%2C%20cinematic%20mood&width=800&height=500&seq=article-cover-14&orientation=landscape',
    author: '吃瓜前线',
    publishDate: '2026-06-30',
    tags: ['偶像', '私联粉丝', '索要礼物', '星辰', '塌房'],
    viewCount: 312500,
    commentCount: 9878,
    isHot: false,
    isNew: false,
  },
  {
    id: '15',
    title: '宠物博主"猫馆长"虐待动物视频外泄，动物保护组织已介入调查',
    slug: 'chongwu-bozhu-nuedai-dongwu',
    category: '热门爆料',
    categorySlug: 'remen-baoliao',
    summary: '以"爱猫如命"人设走红的宠物博主猫馆长，被前员工曝光其在拍摄过程中为博眼球而虐待猫咪的视频，画面令人发指。',
    content: `<p>一则令人愤怒的视频在6月29日深夜开始在网络流传。视频中，以"爱猫人士"、"猫咪守护者"自称的宠物博主"猫馆长"，在拍摄过程中为了激发出猫咪的"有趣反应"，竟然使用多种手段惊吓和虐待猫咪。</p><p>视频由猫馆长的前助理匿名提供。画面中可以看到，为了拍摄"猫咪害怕黄瓜"的视频，工作人员反复将猫咪逼到角落并强行让猫咪面对黄瓜；为了拍摄"猫咪洗澡"的视频，在猫咪明显抗拒的情况下仍强行将其按入水中。视频中还出现了疑似电击项圈的镜头。</p><p>该视频一经发布，动物保护组织和爱宠人士的怒火被瞬间点燃。多个城市的动物保护协会发表联合声明，强烈谴责这种以虐待动物博取流量的行为，并表示已向公安机关报案。</p><p>猫馆长的账号在事件曝光后被平台第一时间封禁。其工作室所在辖区的派出所也已介入调查。据律师分析，若虐待行为属实，猫馆长可能面临行政处罚甚至刑事责任。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cat%20in%20studio%20setting%20with%20soft%20lighting%2C%20pet%20photography%20scene%2C%20warm%20cozy%20atmosphere%2C%20professional%20studio%20environment%2C%20editorial%20style%2C%20gentle%20mood%2C%20clean%20minimal%20background&width=800&height=500&seq=article-cover-15&orientation=landscape',
    author: '深度吃瓜',
    publishDate: '2026-06-30',
    tags: ['宠物博主', '虐待动物', '猫馆长', '动物保护', '封号'],
    viewCount: 445200,
    commentCount: 15678,
    isHot: false,
    isNew: false,
  },
  {
    id: '16',
    title: '知识博主"博士说"抄袭海外论文实锤，万字长文逐一比对证据确凿',
    slug: 'zhishi-bozhu-boshi-chaoxi-lunwen',
    category: '热门爆料',
    categorySlug: 'remen-baoliao',
    summary: '以"清华博士"身份讲解科普知识的博主"博士说"，被网友发现其视频内容大段翻译自海外论文和科普网站，且从未标注出处。',
    content: `<p>又一位"学霸"人设的博主翻车了。自称"清华博士"的知识科普博主"博士说"（真名：王某），被多名网友联合"扒皮"——其发布的数百条科普视频中，有大量内容直接翻译自海外学术论文和科普网站，且从未标注任何引用来源。</p><p>一位在海外读博的网友首先发现了问题："有期视频讲的是量子计算，我听着特别耳熟，后来发现几乎就是我导师那篇论文的中文翻译版，连论证顺序都一模一样。"</p><p>随后，更多的网友加入了"考古"队伍。经过系统比对，至少有40期视频存在不同程度的抄袭行为，涉及物理学、生物学、心理学等多个领域。有网友甚至整理出了一份详细的"抄袭对比表"，将原作与博士说的视频逐段对照，抄袭比例一目了然。</p><p>更尴尬的是，博士说在一次直播中还被网友"钓鱼"提问了一个看似简单但实际需要深入理解才能回答的问题，结果他支支吾吾答不上来——"如果真懂这些论文，不可能连基础问题都答不出"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Academic%20library%20setting%20with%20bookshelves%20and%20study%20desk%2C%20laptop%20with%20papers%20scattered%2C%20warm%20reading%20lamp%20light%2C%20intellectual%20atmosphere%2C%20editorial%20style%2C%20clean%20composition%2C%20moody%20academic%20vibe&width=800&height=500&seq=article-cover-16&orientation=landscape',
    author: '匿名爆料者',
    publishDate: '2026-06-29',
    tags: ['知识博主', '抄袭', '论文', '翻车', '博士', '学术不端'],
    viewCount: 267800,
    commentCount: 8321,
    isHot: false,
    isNew: false,
  },
];

export const getHotArticles = (): Article[] => {
  return articles.filter((a) => a.isHot).sort((a, b) => (a.featuredOrder || 0) - (b.featuredOrder || 0));
};

export const getLatestArticles = (limit: number = 10): Article[] => {
  return [...articles].sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()).slice(0, limit);
};

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.categorySlug === categorySlug).sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRelatedArticles = (article: Article, limit: number = 4): Article[] => {
  return articles
    .filter((a) => a.id !== article.id)
    .sort((a, b) => {
      const sameCategory = a.categorySlug === article.categorySlug ? -1 : 1;
      return sameCategory || new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime();
    })
    .slice(0, limit);
};

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};